import type { Environment } from 'config/environment'
import { fetchEnvironment } from 'config/environment'

import { track } from 'modules/core/lib/Tracking'

const BROKEN_TIMEOUT_HOURS = 1 // Amount of hours to wait before checking for broken versions
const CATCH_ALL_VERSION = '*' // Wildcard to catch all versions

// This function checks if the current release version is a problematic one (is
// performing a DDOS), comparing the sha with the list of reported broken
// versions in the fresh `environment.json` object
export default function brokenVersionChecker(environment: Environment) {
  setInterval(fetchRelease, BROKEN_TIMEOUT_HOURS * 60 * 60 * 1000)

  async function fetchRelease() {
    // Fetch a fresh environment object with the latest list of broken versions
    const { brokenVersions, brokenPeriods } = await fetchEnvironment()

    const brokenByPeriod = !isNaN(Number(environment.releaseDate)) // Capturing 'unknown' too
      ? brokenPeriods.find(([start, end]) => {
          const releaseDate = new Date(Number(environment.releaseDate) * 1000)
          const startDate = new Date(Number(start) * 1000)
          const endDate = new Date(Number(end) * 1000)

          return startDate < releaseDate && endDate > releaseDate
        })
      : null

    // Compare the current release version (stored statically in the code with
    // the environment variable process.env) with the list of broken versions
    // from the fresh environment object
    if (
      brokenVersions.includes(environment.releaseVersion) ||
      brokenVersions.includes(CATCH_ALL_VERSION) ||
      brokenByPeriod
    ) {
      track('Reload broken app', {
        current: environment.releaseVersion,
        date: environment.releaseDate,
        period: brokenByPeriod,
      })

      window.location.reload()
    }
  }
}
